import React, { useState } from 'react';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import { Theme } from '../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../Components/Button/LinkButton';
import ElectronicExaminationSearchVLModal from '../SearchVL/ElectronicExaminationSearchVLModal';
import { useNCZIContext } from '../../../Services/NCZIContext';
import { ElectronicExaminationSearchVLValues } from '../SearchVL/ElectronicExaminationSearchVLModalContent';

//@ts-ignore
import styles from './ElectronicExaminationList.module.scss';
import useNCZICommandProcess from '../../../Hooks/useNCZICommandProcess';
import { NCZIEhrExtractEnvelope } from '../../../Interfaces/ncziTypes';
import NCZICommandResult from '../../NCZICommandResult/NCZICommandResult';
import { GetPatientDPNHistory } from '../../../Commands/GetPatientDPNHistory';
import { GetPatientExaminationListForApplicant } from '../../../Commands/GetPatientExaminationListForApplicant';
import EHRResult from '../../EHR/EHRResult/EHRResult';
import ElectronicExaminationVLSearchResultItems from './VLSearchResult/ElectronicExaminationVLSearchResultItems';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
}

const ElectronicExaminationVLList: React.FC<Props> = () => {
	const [searchOpened, setSearchOpened] = useState<boolean>(false);
	const { patientIdentifier } = useNCZIContext();
	const [searchResult, setSearchResult] =
		useState<NCZIEhrExtractEnvelope | null>(null);

	const { processingCommandId, processCommand, isProcessing } =
		useNCZICommandProcess({
			onFinish: (commandId, result) => {
				setSearchResult(result);
				console.log({ result });
			},
			hideSuccess: true,
		});

	const handleOpenSearchVL = () => {
		setSearchOpened(true);
	};

	const handleSearchSubmit = async (
		values: ElectronicExaminationSearchVLValues,
	) => {
		const GetExaminationList = GetPatientExaminationListForApplicant({
			patientCode: patientIdentifier!,
			itemType: 'VYMENNYLISTOK',
			itemId: values.rcId,
		});

		await processCommand(GetExaminationList);
	};

	const resultItems = searchResult?.ehrExtract?.items[0]?.items || [];

	return (
		<div className={styles.wrapper}>
			<div className={styles.contentWrapper}>
				<div className={styles.controls}>
					<LinkButton
						title='nczi.examination.vl.search.title'
						theme={Theme.BLUE}
						onClick={handleOpenSearchVL}
						firstUpper
					/>
				</div>
				<ScrollContainer>
					<div className={styles.content}>
						{isProcessing && processingCommandId && (
							<div className={styles.loadingWrapper}>
								<NCZICommandResult commandId={processingCommandId} />
							</div>
						)}
						{searchResult && (
							<>
								<EHRResult ehrResult={searchResult?.result} />
								<ElectronicExaminationVLSearchResultItems
									patientIdentifier={patientIdentifier!}
									items={resultItems}
									onCloseDetail={() => {}}
								/>
							</>
						)}
					</div>
				</ScrollContainer>
			</div>
			<ElectronicExaminationSearchVLModal
				opened={searchOpened}
				onClose={() => setSearchOpened(false)}
				onSubmit={handleSearchSubmit}
			/>
		</div>
	);
};

export default ElectronicExaminationVLList;
